export default __webpack_public_path__ + "static/media/devprimebackend.47dc1353.png";